import Swiper from 'swiper';

export default function carouselSales() {

    $('.swiper-container:not(".gallery-img, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

        let $this = $(this),
            $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

        $this.addClass('instance-' + index);
        $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
        $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

        if ($(this).hasClass('sales-carousel')) {
            let mySwiper = new Swiper('.instance-' + index, {
                speed: 500,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-next-btn-' + index,
                    prevEl: '.swiper-prev-btn-' + index
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
            });
        }
    });
}